/* file description */

import { TransformNalmalType2TableColumn } from './type';
import { VALUE_TYPES } from './consts';
import { getModuleRecordList } from '@/common/asset-apis/assetModel';
import { message } from 'antd';
import _ from 'lodash';
import { Api as FetchAPI } from '@/utils';

export const transformAseetCheckboxColumn: TransformNalmalType2TableColumn = ({
  targetColumn,
  field,
  // FetchAPI,
}) => {
  // console.groupCollapsed(`${field?.label}#${field?.name} transformAseetCheckboxColumn`);
  // console.log('入参field', _.cloneDeep(field));
  // console.log('入参targetColumn', _.cloneDeep(targetColumn));

  const { dataKey, treeId, prefilter, isFilter, label, value, dataType } = field?.bizConfig || {};
  targetColumn.valueType = VALUE_TYPES.CHECKBOX;
  targetColumn.request = async () => {
    try {
      const res = await getModuleRecordList(
        FetchAPI,
        treeId,
        dataKey,
        {
          moduleID: dataKey,
          namespaceID: treeId,
          limit: 100,
          incPageNavigation: true,
          incTotal: true,
          filter: isFilter ? (dataType || prefilter) : '',
        },
      );
      const { set = [] } = res || {};
      return set.map((item: any) => {
        const { values = [] } = item || {};
        const tLabel = values.find((v: any) => v.name === label)?.value;
        const tValue = values.find((v: any) => v.name === value)?.value;
        return {
          label: tLabel,
          value: tValue,
        };
      });
    } catch (error) {
      message.error(`请求字段-${field.name}-的选择项失败!`);
      console.error(error);
      return [];
    }
  };

  // console.log('处理后targetColumn', _.cloneDeep(targetColumn));
  // console.groupEnd();

  return targetColumn;
};
